import { useEffect } from 'react';

interface SEOHeadProps {
  title: string;
  description: string;
  keywords: string;
  canonicalUrl?: string;
  ogType?: string;
  schemaJson?: Record<string, unknown>;
}

export default function SEOHead({ title, description, keywords, canonicalUrl, ogType = 'website', schemaJson }: SEOHeadProps) {
  useEffect(() => {
    document.title = title;

    const setMeta = (name: string, content: string, isProperty = false) => {
      const attr = isProperty ? 'property' : 'name';
      let el = document.querySelector(`meta[${attr}="${name}"]`);
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    setMeta('description', description);
    setMeta('keywords', keywords);
    setMeta('og:title', title, true);
    setMeta('og:description', description, true);
    setMeta('og:type', ogType, true);
    if (canonicalUrl) {
      setMeta('og:url', canonicalUrl, true);
      let link = document.querySelector('link[rel="canonical"]');
      if (!link) {
        link = document.createElement('link');
        link.setAttribute('rel', 'canonical');
        document.head.appendChild(link);
      }
      link.setAttribute('href', canonicalUrl);
    }

    if (schemaJson) {
      let script = document.querySelector('script[data-dynamic-schema]');
      if (!script) {
        script = document.createElement('script');
        script.setAttribute('type', 'application/ld+json');
        script.setAttribute('data-dynamic-schema', 'true');
        document.head.appendChild(script);
      }
      script.textContent = JSON.stringify(schemaJson);
    }

    return () => {
      const ds = document.querySelector('script[data-dynamic-schema]');
      if (ds) ds.remove();
    };
  }, [title, description, keywords, canonicalUrl, ogType, schemaJson]);

  return null;
}